import React from 'react'
import RoutesLayout from './LayoutRoutes/Routes'

const App = () => {
  return (
    <div>
      <RoutesLayout />

    </div>
  )
}

export default App